module.exports = __webpack_public_path__ + "img/f27.c84faf82.jpg";